"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../util/index");

var restpaginator_1 = require("../restpaginator");

var channeldescriptor_1 = require("../channeldescriptor");
/**
 * Users channels collection
 * It's a cassandra-backed pull-based collection
 */


var UserChannels = function () {
  function UserChannels(client, services, url) {
    (0, _classCallCheck3["default"])(this, UserChannels);
    this.client = client;
    this.services = services;
    this.url = url;
  }

  (0, _createClass3["default"])(UserChannels, [{
    key: "getChannels",
    value: function () {
      var _ref = (0, _asyncToGenerator3["default"])(
      /*#__PURE__*/
      _regenerator2["default"].mark(function _callee() {
        var _this = this;

        var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var url, response;
        return _regenerator2["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = new index_1.UriBuilder(this.url).arg('PageToken', args.pageToken).build();
                _context.next = 3;
                return this.services.network.get(url);

              case 3:
                response = _context.sent;
                return _context.abrupt("return", new restpaginator_1.RestPaginator(response.body.channels.map(function (x) {
                  return new channeldescriptor_1.ChannelDescriptor(_this.client, x);
                }), function (pageToken) {
                  return _this.getChannels({
                    pageToken: pageToken
                  });
                }, response.body.meta.previous_token, response.body.meta.next_token));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getChannels() {
        return _ref.apply(this, arguments);
      }

      return getChannels;
    }()
  }]);
  return UserChannels;
}();

exports.UserChannels = UserChannels;